import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { coreConfig } from '../../config/core';
import { Button, Card, CardBody } from '../../components/ui';

interface PendingApprovalLocationState {
  message?: string;
}

export const PendingApproval: React.FC = () => {
  const location = useLocation();
  const { message } = (location.state as PendingApprovalLocationState | null) ?? {};

  const body =
    message ??
    `Your account has been registered. An administrator must activate your account before you can use ${coreConfig.applicationDisplayName}.`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Account pending approval
          </h2>
        </div>

        <Card>
          <CardBody className="space-y-6">
            <p className="text-gray-600">{body}</p>
            <Link to="/login">
              <Button fullWidth variant="secondary">
                Back to sign in
              </Button>
            </Link>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};
